<template>
  <div>
    <b-row>
      <b-col lg="6">
        <SelectWithSearch
          label="Class. trib. IBS/CBS"
          v-model="classTribReg"
          :filterBy="taxFilter"
          :change="changeClassTribIBSCBSRegSelected"
          :options="classTribIBSCBSCollection"
        >
          <template slot="options" slot-scope="props">
            <div class="selected">{{ props.data.codigo }} - {{ props.data.descricao }}</div>
          </template>
          <template slot="no-options"> Nenhum resultado encontrado </template>
          <template slot="selected" slot-scope="props">
            <div class="selected">{{ props.data.codigo }} - {{ props.data.descricao }}</div>
          </template>
        </SelectWithSearch>
      </b-col>
      <b-col lg="6">
        <SelectWithSearch
          label="CST IBS/CBS"
          disabled
          v-model="cstReg"
          :filterBy="taxFilter"
          :options="CSTIBSCBSCollection"
        >
          <template slot="options" slot-scope="props">
            <div class="selected">{{ props.data.codigo }} - {{ props.data.descricao }}</div>
          </template>
          <template slot="no-options"> Nenhum resultado encontrado </template>
          <template slot="selected" slot-scope="props">
            <div class="selected">{{ props.data.codigo }} - {{ props.data.descricao }}</div>
          </template>
        </SelectWithSearch>
      </b-col>
    </b-row>
    <b-row class="mt-lg-2">
      <b-col lg="3">
        <InputQuantity
          id="pAliqEfetRegIBSUF"
          label="Alíquota IBS UF"
          inputClass="form-control input"
          labelBold
          v-model="productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.gTribRegular.pAliqEfetRegIBSUF"
          :precision="4"
          :returnFormattedValue="false"
          disabled
          :max="8"
        />
      </b-col>
      <b-col lg="3">
        <InputMoney
          label="Valor IBS UF"
          inputClass="form-control input"
          labelBold
          :precision="2"
          :returnFormattedValue="false"
          v-model="productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.gTribRegular.vTribRegIBSUF"
        />
      </b-col>
      <b-col lg="3">
        <InputQuantity
          id="pAliqEfetRegIBSMun"
          label="Alíquota IBS Mun"
          inputClass="form-control input"
          labelBold
          v-model="
            productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.gTribRegular.pAliqEfetRegIBSMun
          "
          :precision="4"
          :returnFormattedValue="false"
          disabled
          :max="8"
        />
      </b-col>
      <b-col lg="3">
        <InputMoney
          label="Valor IBS Município"
          inputClass="form-control input"
          labelBold
          :precision="2"
          :returnFormattedValue="false"
          v-model="productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.gTribRegular.vTribRegIBSMun"
        />
      </b-col>
    </b-row>
    <b-row class="mt-lg-2">
      <b-col lg="3">
        <InputQuantity
          id="pAliqEfetRegCBS"
          label="Alíquota CBS"
          inputClass="form-control input"
          labelBold
          v-model="productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.gTribRegular.pAliqEfetRegCBS"
          :precision="4"
          :returnFormattedValue="false"
          disabled
          :max="8"
        />
      </b-col>
      <b-col lg="3">
        <InputMoney
          label="Valor CBS"
          inputClass="form-control input"
          labelBold
          :precision="2"
          :returnFormattedValue="false"
          v-model="productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.gTribRegular.vTribRegCBS"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { SelectWithSearch, InputQuantity, InputMoney } from '@/components/Form';

export default {
  name: 'TribRegular',
  components: {
    InputMoney,
    InputQuantity,
    SelectWithSearch,
  },
  data() {
    return {
      classTribReg: null,
      cstReg: null,
      taxFilter(option, _, search) {
        if (!search) return true;

        const searchToLower = search.toLowerCase();

        const codigoMatch = option.codigo
          ?.toString()
          .toLowerCase()
          .includes(searchToLower);
        const descricaoMatch = option.descricao
          ?.toString()
          .toLowerCase()
          .includes(searchToLower);

        return codigoMatch || descricaoMatch;
      },
    };
  },
  computed: {
    ...mapState('purchase', ['productOfPurchaseOnFiscalEdit']),
    ...mapState('ibsRegime', ['classTribIBSCBSCollection', 'CSTIBSCBSCollection']),
  },
  mounted() {
    const classTrib = this.classTribIBSCBSCollection.find(
      (e) =>
        e.codigo ===
        this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime?.gTribRegular?.cClassTribReg,
    );

    const cst = this.CSTIBSCBSCollection.find(
      (e) =>
        e.codigo === this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime?.gTribRegular?.CSTReg,
    );

    if (classTrib) {
      this.classTribReg = classTrib;
    }

    if (cst) {
      this.cstReg = cst;
    }
  },
  methods: {
    changeClassTribIBSCBSRegSelected(selectedClassTribIBSCBSReg) {
      this.$emit('onChangeCClassTribReg', selectedClassTribIBSCBSReg);

      if (selectedClassTribIBSCBSReg) {
        this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.gTribRegular.cClassTribReg =
          selectedClassTribIBSCBSReg.codigo;

        this.classTribReg = {
          ...selectedClassTribIBSCBSReg,
        };

        const cstCode = selectedClassTribIBSCBSReg.codigo.substring(0, 3);

        const cst = this.CSTIBSCBSCollection.find((e) => e.codigo === cstCode);

        this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.gTribRegular.CSTReg = cst.codigo;

        this.cstReg = {
          ...cst,
        };

        return;
      }

      this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.gTribRegular.cClassTribReg = null;
      this.classTribReg = null;
      this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.gTribRegular.CSTReg = null;
      this.cstReg = null;
    },
  },
};
</script>
